import { render, staticRenderFns } from "./IconCoordinator.vue?vue&type=template&id=6a54a4bc"
import script from "./IconCoordinator.vue?vue&type=script&lang=js"
export * from "./IconCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports